// Logo
export const logoText = "Aurus";
export const logoTagline = "Real estate made simple";

// Login
export const OTP_RESEND_INTERVAL = 30; // in seconds
export const MAX_OTP_LENGTH = 6;

// File Uploads

export const allowedFileTypes = {
  images: ["image/jpeg", "image/png"],
  documents: ["application/pdf", "application/msword"],
  videos: ["video/mp4", "video/mkv"],
};

export const UploadFileTypes = {
  IMAGES: "images",
  DOCUMENTS: "documents",
  VIDEOS: "videos",
};

export const FileTypes = {
  COMPANY_LOGO: UploadFileTypes.IMAGES,
  AADHAR: UploadFileTypes.IMAGES,
  PAN: UploadFileTypes.IMAGES,
  PROJECT_LAYOUT: UploadFileTypes.IMAGES,
  DRONE_VIDEO: UploadFileTypes.VIDEOS,
  IMAGE_SLIDER: UploadFileTypes.IMAGES,
  BROCHURE: UploadFileTypes.DOCUMENTS,
  MASTERFILE: UploadFileTypes.DOCUMENTS,
  RERA_CERTIFICATE: UploadFileTypes.DOCUMENTS,
  BANK_IDENTIFICATION: UploadFileTypes.IMAGES,
};

// --------- Form Options for Select Inputs -----------
export const emiOptions = Array.from({ length: 48 }).map((_, i) => ({
  value: `${i + 1}`,
  label: `${i + 1} months`,
}));

export const projectTypeOptions = [
  { value: "R Zone", label: "R Zone" },
  { value: "NA", label: "NA" },
  { value: "Proposed NA", label: "Proposed NA" },
];

export const commissionPayableToAgentOptions = [
  { value: "8%", label: "8%" },
  { value: "9%", label: "9%" },
  { value: "10%", label: "10%" },
  { value: "11%", label: "11%" },
  { value: "12%", label: "12%" },
  { value: "13%", label: "13%" },
  { value: "14%", label: "14%" },
  { value: "15%", label: "15%" },
];

export const ratePerDayToHoldPlotOptions = [
  { value: "50", label: "₹50" },
  { value: "100", label: "₹100" },
  { value: "150", label: "₹150" },
  { value: "200", label: "₹200" },
  { value: "250", label: "₹250" },
  { value: "300", label: "₹300" },
  { value: "350", label: "₹350" },
  { value: "400", label: "₹400" },
  { value: "450", label: "₹450" },
  { value: "500", label: "₹500" },
];

export const daysToHoldPlotOptions = [
  { value: 1, label: "1 Day" },
  { value: 2, label: "2 Days" },
  { value: 3, label: "3 Days" },
  { value: 4, label: "4 Days" },
  { value: 5, label: "5 Days" },
  { value: 6, label: "6 Days" },
  { value: 7, label: "7 Days" },
  { value: 8, label: "8 Days" },
  { value: 9, label: "9 Days" },
  { value: 10, label: "10 Days" },
];

export const commissionPayableToCompanyOptions = [
  { value: "8%", label: "8%" },
  { value: "9%", label: "9%" },
  { value: "10%", label: "10%" },
  { value: "11%", label: "11%" },
  { value: "12%", label: "12%" },
  { value: "13%", label: "13%" },
  { value: "14%", label: "14%" },
  { value: "15%", label: "15%" },
];

export const colorOptions = [
  "#56AEE2",
  "#56E2CF",
  "#56E289",
  "#AEE256",
  "#68E256",
  "#E2CF56",
  "#E28956",
  "#E25668",
  "#E256AE",
  "#CF56E2",
  "#8A56E2",
  "#5668E2",
];

export const validMapsUrls = [
  "https://www.google.com/maps/place",
  "https://www.google.com/maps",
  "https://maps.app.goo.gl",
  "https://www.google.com/maps",
  "https://maps.google.com",
];
